!function(a) {
    "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : jQuery)
}(function(a) {
    function c(a, b) {
        return a.toFixed(b.decimals)
    }
    var b = function(c, d) {
        this.$element = a(c),
        this.options = a.extend({}, b.DEFAULTS, this.dataOptions(), d),
        this.init()
    };
    b.DEFAULTS = {
        from: 0,
        to: 0,
        speed: 1e3,
        refreshInterval: 100,
        decimals: 0,
        formatter: c,
        onUpdate: null,
        onComplete: null
    },
    b.prototype.init = function() {
        this.value = this.options.from,
        this.loops = Math.ceil(this.options.speed / this.options.refreshInterval),
        this.loopCount = 0,
        this.increment = (this.options.to - this.options.from) / this.loops
    }
    ,
    b.prototype.dataOptions = function() {
        var a = {
            from: this.$element.data("from"),
            to: this.$element.data("to"),
            speed: this.$element.data("speed"),
            refreshInterval: this.$element.data("refresh-interval"),
            decimals: this.$element.data("decimals")
        }
          , b = Object.keys(a);
        for (var c in b) {
            var d = b[c];
            "undefined" == typeof a[d] && delete a[d]
        }
        return a
    }
    ,
    b.prototype.update = function() {
        this.value += this.increment,
        this.loopCount++,
        this.render(),
        "function" == typeof this.options.onUpdate && this.options.onUpdate.call(this.$element, this.value),
        this.loopCount >= this.loops && (clearInterval(this.interval),
        this.value = this.options.to,
        "function" == typeof this.options.onComplete && this.options.onComplete.call(this.$element, this.value))
    }
    ,
    b.prototype.render = function() {
        var a = this.options.formatter.call(this.$element, this.value, this.options);
        this.$element.text(a)
    }
    ,
    b.prototype.restart = function() {
        this.stop(),
        this.init(),
        this.start()
    }
    ,
    b.prototype.start = function() {
        this.stop(),
        this.render(),
        this.interval = setInterval(this.update.bind(this), this.options.refreshInterval)
    }
    ,
    b.prototype.stop = function() {
        this.interval && clearInterval(this.interval)
    }
    ,
    b.prototype.toggle = function() {
        this.interval ? this.stop() : this.start()
    }
    ,
    a.fn.countTo = function(c) {
        return this.each(function() {
            var d = a(this)
              , e = d.data("countTo")
              , f = !e || "object" == typeof c
              , g = "object" == typeof c ? c : {}
              , h = "string" == typeof c ? c : "start";
            f && (e && e.stop(),
            d.data("countTo", e = new b(this,g))),
            e[h].call(e)
        })
    }
});